/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ActionsToTakeTypeEnum = {
    ForterDecisionChallenge: 'forter_decision_challenge',
    Forter3dsChallenge: 'forter_3ds_challenge',
    Redirect: 'redirect',
    RevolutPayment: 'revolut_payment'
};
/**
 * Check if a given object implements the ActionsToTake interface.
 */
export function instanceOfActionsToTake(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('paymentId' in value) || value['paymentId'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
export function ActionsToTakeFromJSON(json) {
    return ActionsToTakeFromJSONTyped(json, false);
}
export function ActionsToTakeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'challengeRequest': json['challenge_request'] == null ? undefined : json['challenge_request'],
        'id': json['id'],
        'paymentId': json['payment_id'],
        'redirectUrl': json['redirect_url'] == null ? undefined : json['redirect_url'],
        'type': json['type'],
    };
}
export function ActionsToTakeToJSON(json) {
    return ActionsToTakeToJSONTyped(json, false);
}
export function ActionsToTakeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'challenge_request': value['challengeRequest'],
        'id': value['id'],
        'payment_id': value['paymentId'],
        'redirect_url': value['redirectUrl'],
        'type': value['type'],
    };
}
